<template>
  <v-row dense>
    <v-col>
      <v-card v-for="item in medicalRequestItems" :key="item.id">
        <v-container fluid>
          <v-row dense align="center">
            <v-col cols="auto" class="text-subtitle-2">
              {{ item.name }}
            </v-col>
            <v-spacer />
          </v-row>

          <v-divider />

          <v-row dense>
            <v-col>
              <v-row dense>
                <v-col class="text-subtitle-2"> Encaminhar para </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-combobox
                    label="Encaminhar para"
                    v-model="item.forwardTo"
                    dense
                    outlined
                    clearable
                    :items="doctorUsers"
                    :hide-details="!errors.forwardTo"
                    :error-messages="errors.forwardTo"
                    item-text="employee.name"
                    background-color="white"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="text-subtitle-2"> Hipótese diagnóstica </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <QuerySearchDropdown
                    v-model="item.cid"
                    :query="getCidsQuery"
                    queryKey="cids"
                    label="CID"
                    item-text="codeDescription"
                    input-prompt-text="Digite o nome ou código para pesquisar..."
                    not-found-text="Nenhum CID encontrado."
                    :error-messages="errors.cid"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="text-subtitle-2"> Local </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-combobox
                    v-model="item.site"
                    label="Local"
                    outlined
                    dense
                    :hide-details="!errors.site"
                    :error-messages="errors.site"
                    background-color="white"
                    :items="sites"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="text-subtitle-2"> Observações </v-col>
              </v-row>

              <v-row dense>
                <v-col
                  ><v-text-field
                    v-model="item.observations"
                    label="Observações"
                    dense
                    outlined
                    hide-details
                    placeholder=" "
                    clearable
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-row dense>
                <v-col class="text-subtitle-2"> Procedimento Futuro </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  <MedicalRequestItemPlannedDateForm
                    :plannedDate="item.plannedDate"
                    @update:plannedDate="updateItemPlannedDate(item, $event)"
                    :error-messages="errors.plannedDate"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="text-subtitle-2"> Acompanhamento </v-col>
              </v-row>

              <v-switch
                v-model="item.followUp"
                dense
                class="v-input--reverse font-weight-bold">
              </v-switch>
             </v-col>
           </v-row>

          <v-row>
          </v-row>
        </v-container>
      </v-card>
      <v-row>
        <v-col class="text-right">
          <v-btn color="light-blue" dark @click="saveExamRequest">
            salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import QuerySearchDropdown from "@/components/ui/form/query_search_dropdown.vue";
import MedicalRequestItemPlannedDateForm from "@/components/medical_request/medical_request_item/planned_date_form.vue";

export default {
  name: "MedicalRequestItems",
  components: { QuerySearchDropdown, MedicalRequestItemPlannedDateForm },
  props: {
    medicalRequestItems: Array,
    doctorUsers: Array,
    sites: Array,
    attendance: Object,
    requester: {},
    forwardTo: {},
    cid: {},
    observations: String,
    site: String,
    reason: String,
    emergency: Boolean,
    validateMedicalRequest: Function,
    followUp: Boolean,
  },
  data() {
    return {
      getCidsQuery: require("@/graphql/cids.gql"),
      errors: {},
    };
  },
  beforeUpdate() {
    this.updateCid();
    this.updateForwardTo();
    this.updateSite();
    this.updateObservations();
  },
  mounted() {
    this.forceUpdateMedicalRequestItems();
  },
  methods: {
    forceUpdateMedicalRequestItems() {
      // Due to Vue's reactivity the array prop is not loaded correctly at first.
      // Force reloading remedies this issue.
      // Source: https://v2.vuejs.org/v2/guide/reactivity.html#For-Arrays
      this.medicalRequestItems.forEach((item, index) => {
        this.$set(this.medicalRequestItems, item, index);
      });
    },
    updateCid() {
      if (this.cid) {
        this.medicalRequestItems.forEach((e) => {
          if (e.cid == "" || e.cid == undefined) e.cid = this.cid;
        });
      }
    },
    updateForwardTo() {
      if (this.forwardTo) {
        this.medicalRequestItems.forEach((e) => {
          if (e.forwardTo == "" || e.forwardTo == undefined)
            e.forwardTo = this.forwardTo;
        });
      }
    },
    updateSite() {
      if (this.site) {
        this.medicalRequestItems.forEach((e) => {
          if (e.site == "" || e.site == undefined) e.site = this.site;
        });
      }
    },
    updateObservations() {
      if (this.observations) {
        this.medicalRequestItems.forEach((e) => {
          if (e.observations == "" || e.observations == undefined || e.observations == null)
            e.observations = this.observations;
        });
      }
    },
    updateObservationsWithSite(observations, site){
      if (observations == "" || observations == undefined || observations == null){
        return site
      }

      return observations + " " + site ;
    },
    sumRequestedQuantity(name, site) {
      if (name.length > 0 && name.toLowerCase().includes('consulta')) {
        return 1;
      }

      if (site === "Ambos os olhos" || site === "Ambas pálpebras" ) {
        return 2;
      } else {
        return 1;
      }
    },
    validate() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      this.medicalRequestItems.forEach((e) => {
        if (!e.cid?.id) {
          this.errors.cid = errorMsg;
        }
        if (this.lodash.isEmpty(e.site?.trim())) {
          this.errors.site = errorMsg;
        }
        if(!e.forwardTo?.id) {
          this.errors.forwardTo = errorMsg;
        }
      });

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
    saveExamRequest() {
      if (!this.validateMedicalRequest()) return;
      if (!this.validate(this.medicalRequestItems)) return;

      this.$store.dispatch("updateLoading", true);

      this.medicalRequestItems.forEach((e) => {
        this.apolloMutate({
          mutation: require("@/graphql/medical_request/save_medical_requests.gql"),
          variables: {
            attendanceId: this.attendance.id,
            requesterId: this.requester.id,
            forwardToId: this.lodash.get(e.forwardTo, "id", ""),
            cidId: e.cid.id,
            observation: this.updateObservationsWithSite(e.observations, e.site),
            site: e.site,
            medicalRequestItemId: e.id,
            reason: e.cid.description,
            requestedQuantity: this.sumRequestedQuantity(e.name, e.site),
            emergency: this.emergency,
            plannedDate: e.plannedDate,
            followUp: e.followUp,
          },
        });
        e.cid = "";
        e.site = "";
        e.observations = "";
        e.forwardToId = "";
      });
      this.$router.push(`/prontuario/${this.attendance.id}/solicitacao-exames`);
    },
    updateItemPlannedDate(item, value) {
      item.plannedDate = value;
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped></style>
